module.exports = __webpack_public_path__ + "static/media/ic-category-setup-off.bc11be87.svg";